import { queryOptions } from '@tanstack/react-query';

import { fetchBracket } from '@apis/bracket';

export const getBracketQuery = (params: Parameters<typeof fetchBracket>[0]) =>
  queryOptions({
    queryKey: ['bracket', params],
    queryFn: ({ signal }) => fetchBracket(params, signal),
    select: (response) => response?.data,
    placeholderData: { data: [] },
  });
